const emailRegex =
	/^([a-zA-Z0-9.!#$%&'*/=?^_`{}~;|\-"]{1,64})@([a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9])\.[a-zA-Z]{2,4}$/;
const nameRegex = /^[a-zA-Z][a-zA-Z' -]*$/;
const phoneNumberRegex = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;
const defaultMessage = 'This field is required';

export function validateName(value: string, errorMessage = defaultMessage, length = 0) {
	if (!value?.trim()?.length) {
		return errorMessage;
	}
	// We allow spaces, single quotes, and dashes
	if (!nameRegex.test(value)) {
		return "Invalid character. Use only A-Z, hyphens ( - ), and single quotes ( ' ).";
	}
	if (length && value.length > length) {
		return `Field can't exceed ${length} characters`;
	}
	return true;
}

export function validatePhone(value: string, errorMessage = defaultMessage) {
	if (!value?.trim()?.length) {
		return errorMessage;
	}
	// Allows (###) ###-####
	if (!phoneNumberRegex.test(value)) {
		return 'Sorry, that seems to be an invalid phone number.';
	}
	return true;
}

export function validateEmail(value: string, errorMessage = defaultMessage) {
	if (!value?.trim()?.length) {
		return errorMessage;
	}
	//The email's 'local-part,' cannot start with 'www.', 'http', or '.'
	const isInvalidLocalPart =
		['www.', 'http'].includes(value.substring(0, 4).toLowerCase()) || value.startsWith('.');

	if (isInvalidLocalPart || !emailRegex.test(value)) {
		return 'Sorry, that seems to be an invalid email format.';
	}
	return true;
}
